module.exports = __webpack_public_path__ + "img/RETURN_SALE.e0486ef5.svg";